import { t } from "i18next";
import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getMisc, getOrganizationsPoolsData } from "../../apiclients/streamsapi_bridge";
import DeleteOrgORPool from "../../views/popups/orggroups/deleteOrg";
import NewPool from "../../views/popups/orggroups/NewPool";
import PopupLoader from "../../views/popups/PopupLoader";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";

export default function OrganizationPools(isActive) {

    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);

    const [listOrgPoolData, setListOrgPoolData] = useState([]);

    const [poolId, setPoolId] = useState(-1);
    const [deletePoolFlag, setDeletePoolFlag] = useState(false);
    const toggleDelPool = () => setDeletePoolFlag(!deletePoolFlag);

    const [addPool, setAddPool] = useState(false);
    const addOrgPoolOpen = () => setAddPool(!addPool);

    const [selectedOrgPoolInfo, setSelectedOrgPoolInfo] = useState([]);

    const [miscOrgInfo, setMiscOrgInfo] = useState({});
    const [currentpools, setcurrentpools] = useState({});

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
  
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
    const navigate = useNavigate();



    async function getMiscOrgInfo() {
        try {
            const apiResponse = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["org_info"] });
            if (!apiResponse.json) {
                const message = `An error has occured: ${apiResponse.statusText}`;
                return;
            }
            const apiInfo = await apiResponse.json();
            setMiscOrgInfo(apiInfo?.misc?.org_info);


        } catch (e) {
            console.log(`Org Info not available:${e}`);
        }
    }

    useEffect(() => {
        if (addPool == true) {
            // fetching the org Infomation for new Pool Creation.
            getMiscOrgInfo();
        }
    }, [addPool]);

    async function onRowClick(e) {
        //   await getMiscOrgInfo();
        setSelectedOrgPoolInfo(e.poolInfo ?? {});
        console.log(`PoolObj:::${JSON.stringify(e.poolInfo ?? {})}`);
        navigate("/pooledit", {
            state: e.poolInfo ?? {},
        });

    }

    function deleteOrg(event, ele) {
        event.preventDefault();
        event.stopPropagation();
        setPoolId(ele?.poolid);
        toggleDelPool();
        setcurrentpools(ele)

    }

    const actionData = {
        columns: [
            { label: 'Pool Name', field: 'pool_name'},
            // { label: "", field: "defaultPool", sort: false, colSpan: 1 },
            { label: 'Org Name', field: 'org_name' },
            { label: 'Remove', field: 'delete', sort: false },
        ],
        rows: []
    }

   useEffect(() => { 
    actionData.rows = listOrgPoolData.map((poolObj) => ({
        org_name: poolObj.org_name,
        // defaultPool: (
        //     <div>
        //         {poolObj.pool_name && poolObj.pool_name === "Default Pool" && (
        //             <>
        //             <div className="d-flex">
        //                 <div className="px-2 ms-2 border border-1 rounded-pill border-success text-center">
        //                     <span className="small text-success">Primary</span>
        //                 </div>
        //             </div>
        //             </>
        //         )}

        //     </div>
        // ),
        pool_name: poolObj.pool_name + (poolObj.pool_name && poolObj.pool_name === "Default Pool" ? " (Default)": ""),
        orgid: poolObj.orgid,
        poolInfo: poolObj,
        delete: (
            <>
                {!(poolObj.pool_name && poolObj.pool_name === "Default Pool") && (
                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                            onClick={(e) => deleteOrg(e, poolObj)}
                        >
                            <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                    </div>
                )}
            </>
        )

    }));
    setRowData(actionData.rows);
    setFilteredRows(actionData.rows)
    setDataLoaded(true)

},[listOrgPoolData,isActive])

    async function getAllOrgPoolData() {
        try {
            setIsloading(true);
            const response = await getOrganizationsPoolsData(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.ORG_POOLS_SUBLINK
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const allOrgGrpData = await response.json();
            if (response.status == 200) {
                setListOrgPoolData(allOrgGrpData.all_pools ?? []);
                console.log("org pool data :::" + JSON.stringify(allOrgGrpData.all_pools ))
            } else {
                setInternalError(true);
            }

        } catch (error) {
            console.log(`Unable to process org req:${error}`);
            setInternalError(true);
        }
    }
    useEffect(() => {
        // fetching the organizations information
        getAllOrgPoolData();
    }, []);


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.ORGANIZATION_POOLS);

        setFilteredRows(filteredUsers);
    };


    return (
        <>
            <div className="OrgPoolDataTable">
                <div className="actionbar">
                    <MDBBtn onClick={addOrgPoolOpen}>
                        New Pool
                    </MDBBtn>
                </div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable key={searchValue}
                hover 
                data={{
                    ...actionData,
                    rows: filteredRows, // Use filtered rows here
                  }}
                entries={50}
                    sortField="Pool Name" onRowClick={onRowClick} />
            </div>

            {
                isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )
            }
            {deletePoolFlag && (

                <PopupLoader
                    title={t("Remove_Pool")}
                    content={
                        <DeleteOrgORPool
                            id={poolId}
                            delType={2}
                            title={t("Remove_Pool")}
                            onClose={toggleDelPool}
                            orgData = {currentpools}
                        />
                    }
                    onClose={toggleDelPool}
                />
            )
            }
            {addPool && addPool == true && (

                <PopupLoader
                    title={"Add New Pool"}
                    content={
                        <NewPool
                            onClose={addOrgPoolOpen}
                            orgList={miscOrgInfo.org_names}
                        />
                    }
                    onClose={addOrgPoolOpen}
                />
            )
            }
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="top-center"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    );
}